export default {"src":"/_next/static/media/apple.23b88012.svg","height":22,"width":22};